import { UseQueryResult, useQuery } from 'react-query';
import { Api } from 'lavva.exalushome';
import { IWebCamsService } from 'lavva.exalushome.webcams/build/js/IWebCamsService';
import { WebCamsService } from 'lavva.exalushome.webcams/build/js/WebCamsService';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { useBackdropContext } from '../../../context/backdrop';
import { useExalusContext } from '../context';

export const useExalusCameraStream = (channel?: IDeviceChannel): UseQueryResult<MediaStream | null> => {
  const { connected, selectedExalusCredentials, synchronized, inited } = useExalusContext();
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();

  return useQuery<MediaStream | null>(
    ['exalus-cameras', selectedExalusCredentials?.id, synchronized],
    async () => {
      if (channel) {
        turnOnBackdrop();
        const cameraApi = Api.Get<IWebCamsService>(WebCamsService.ServiceName);
        const cam = await cameraApi.GetWebCamAsync(channel.GetDevice());
        const mediaStream = await cam.GetRTCMediaStreamAsync();
        turnOffBackdrop();
        return mediaStream;
      }

      return null;
    },
    {
      enabled: connected && !!selectedExalusCredentials?.id && synchronized && !!channel?.GetDevice && inited,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onError: () => turnOffBackdrop(),
    },
  );
};
